import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';
import { BodyClassService } from '@df/ui/body-class.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PAGE_HEADER_VERSION_STATE } from './page-header.config';
import { NPageHeader } from './page-header.interface';
import { PageHeaderService } from './page-header.service';

@Directive({
    selector: '[pageHeaderBody]',
    standalone: true
})
export class PageHeaderBodyDirective implements OnDestroy {
    private _enabled = true;
    destroyed = new Subject<void>();

    /**
     * If `false` then reset to default state.
     */
    @Input()
    set pageHeaderBody(value: BooleanInput) {
        this._enabled = coerceBooleanProperty(value);

        this.update();
    }

    /**
     * Current state
     */
    private state?: NPageHeader.IVersionState;

    constructor(
        private pageHeaderService: PageHeaderService,
        private elementRef: ElementRef,
        private renderer2: Renderer2,
        private bodyClassService: BodyClassService
    ) {
        this.pageHeaderService
            .getState()
            .pipe(takeUntil(this.destroyed))
            .subscribe(state => {
                this.state = state;
                this.update();
            });
    }

    ngOnDestroy(): void {
        this.bodyClassService.remove(NPageHeader.EClasses.hideUp, this);
        this.bodyClassService.remove(NPageHeader.EClasses.transparent, this);
        this.destroyed.next();
        this.destroyed.complete();
    }

    private update() {
        const state = this.state;

        if (!state) {
            return;
        }

        const el = this.elementRef.nativeElement;
        let transparent = !!state.transparent;
        let lightMode = !!state.transparent && !!state.lightMode;
        let hideUp = !!state.hideUp;

        if (!this._enabled) {
            transparent = !!PAGE_HEADER_VERSION_STATE.transparent;
            lightMode = !!PAGE_HEADER_VERSION_STATE.lightMode;
            hideUp = !!PAGE_HEADER_VERSION_STATE.hideUp;
        }

        transparent
            ? this.renderer2.addClass(el, NPageHeader.EClasses.transparent)
            : this.renderer2.removeClass(el, NPageHeader.EClasses.transparent);
        lightMode
            ? this.renderer2.addClass(el, NPageHeader.EClasses.lightMode)
            : this.renderer2.removeClass(el, NPageHeader.EClasses.lightMode);
        hideUp ? this.renderer2.addClass(el, NPageHeader.EClasses.hideUp) : this.renderer2.removeClass(el, NPageHeader.EClasses.hideUp);

        this.bodyClassService.set(NPageHeader.EClasses.hideUp, this, hideUp);
        this.bodyClassService.set(NPageHeader.EClasses.transparent, this, transparent);
    }
}
